
import { computed, defineComponent, ref } from "vue";
import ResponseData from '@/_models/ResponseData';
import GameReleaseService from '@/services/GameReleaseService';
import { GameUtils } from "@/utils/GameUtils";
import { useStore } from 'vuex';
import { useRouter } from "vue-router";
import GamesFeedbackModal from "@/modules/games/components/gamesFeedbackModal.vue";
import GamesGalleryComponent from "../components/gallery/gamesGalleryComponent.vue";
import router from "@/router";

export default defineComponent({
  name: "viewGamesDetails",
  props: {
    gameId: String
  },
  components: {
    GamesFeedbackModal,
    GamesGalleryComponent
},
  setup(props){
    const store = useStore();
    const router = useRouter();
    const label = computed(() => {
      return store.getters['config/configLabel'];
    })

    const tags = ref([]);
    const languages = ref([]);
    const title = ref('');
    const about = ref('');
    const contentRating = ref('');
    const version = ref('');
    const submittedById = ref('');
    const headerImage = ref('');
    const gameCategory = ref('');
    const lastUpdate = ref('');
    const submissionDate = ref('');

    // gallery slider
    // const step = ref(0);
    const isEnabledGalleryPreviousButton = computed( () => {
      return stepCount.value > 0;
    });

    const isEnabledGalleryNextButton = computed( () => {
      return gallery.value.length > ((stepCount.value + 1) * 3);
    });

    const stepCount =ref(0);
    const gallery = ref([]);
    const prevSlide = () => {
      --stepCount.value;
      if(stepCount.value == 0){
        for(let i = 0; i < gallery.value.length; i++){
          if(0 <=i && i <= 2){
            gallery.value[i].display = true;
          }else{
            gallery.value[i].display = false;
          }
        }
      }else if(stepCount.value == 1){
        for(let i = 0; i < gallery.value.length; i++){
          if(3 <=i && i <= 5){
            gallery.value[i].display = true;
          }else{
            gallery.value[i].display = false;
          }
        }
      }
    };

    const nextSlide = () => {
      ++stepCount.value;
      if(stepCount.value == 1){
        for(let i = 0; i < gallery.value.length; i++){
          if(3 <=i && i <= 5){
            gallery.value[i].display = true;
          }else{
            gallery.value[i].display = false;
          }
        }
      }else if(stepCount.value == 2){
        for(let i = 0; i < gallery.value.length; i++){
          if(6 <=i && i <= 8){
            gallery.value[i].display = true;
          }else{
            gallery.value[i].display = false;
          }
        }
      }
    };

    const assetURL = computed(() => {
      return store.getters['config/assetUrl'];
    });

    (async() => {
      const gameDetails = await GameUtils.fetchPublishedGame(props.gameId);
      if(!gameDetails){
        router.push('/invalid-game-id');
      }
      title.value = gameDetails.viewModel.game.title;
      submittedById.value = gameDetails.viewModel.game.publishedBy;
      gameCategory.value = gameDetails.viewModel.game.category;
      about.value = gameDetails.viewModel.details.about.about;
      tags.value = gameDetails.viewModel.game.tags;
      contentRating.value = gameDetails.viewModel.game.contentRating;
      version.value = gameDetails.viewModel.game.version;
      languages.value = gameDetails.viewModel.game.languages;
      if(gameDetails.viewModel.details.gallery.headerImage){
        headerImage.value = assetURL.value + `blob/games/${props.gameId}/gallery/${gameDetails.viewModel.details.gallery.headerImage}`;
      }else{
        headerImage.value = 'none';
      }
      if(gameDetails.viewModel.details.gallery.galleryImages.length > 0){
        gameDetails.viewModel.details.gallery.galleryImages.forEach((image, index) => {
          gallery.value.push({
            id: index + 1,
            url: assetURL.value + `blob/games/${props.gameId}/gallery/${image}`,
            itemCount: index + 1,
            display: (index > 2)?false:true,
          });
        });
      }
      await generateGameReleases(props.gameId);
    })()

    const displayFeedbackModal = ref(false);

    const userData = store.getters['auth/user'];
    const jwtToken = store.getters['auth/jwtToken'];
    const webglRelease = ref([]);
    const androidRelease = ref([]);
    const apk = ref('');
    const generateGameReleases = async(gameId) => {
      await GameReleaseService.getReleasesList(gameId, userData.userId, jwtToken)
        .then((response: ResponseData) => {
          if(response.status == 200){
            webglRelease.value = response.data.filter(game => game.platform == 'WebGL').sort((a, b) => b.version > a.version).slice(0, 5);
            androidRelease.value = response.data.filter(game => game.platform == 'Android').slice(0, 5);
            if(androidRelease.value.length > 0){
              apk.value = assetURL.value + 'blob/releases/Android/' + props.gameId + '/' + androidRelease.value[0].package + '.apk';
            }
          }
        })
    };

    return {
      displayFeedbackModal,
      lastUpdate,
      submissionDate,
      submittedById,
      gameCategory,
      tags,
      languages,
      title,
      about,
      contentRating,
      version,
      headerImage,
      stepCount,
      gallery,
      prevSlide,
      nextSlide,
      isEnabledGalleryPreviousButton,
      isEnabledGalleryNextButton,
      // isFeedbackDone,
      webglRelease,
      androidRelease,
      label,
      apk
    }
  },
});
